import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {Styles} from "../../../../config/design/styles";
import {connect, setStore} from "trim-redux";
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import IconButton from "@material-ui/core/IconButton/IconButton";
import Drawer from "@material-ui/core/Drawer";
import TextField from "@material-ui/core/TextField/TextField";
import {Translate} from "../../../../config/Translate";
import {ListItem} from "@material-ui/core";
import List from "@material-ui/core/List/List";
import ListItemText from "@material-ui/core/ListItemText/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction/ListItemSecondaryAction";
import ChevronLeftRoundedIcon from "@material-ui/icons/ChevronLeftRounded";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import FindInPageIcon from '@material-ui/icons/FindInPage';
import Popover from "@material-ui/core/Popover/Popover";
import Box from "@material-ui/core/Box/Box";
import FormatListNumberedRtlRoundedIcon from '@material-ui/icons/FormatListNumberedRtlRounded';
import LowPriorityRoundedIcon from '@material-ui/icons/LowPriorityRounded';

class PlayerPage extends React.Component {
    state = {
        open:false,
        query:this.props.pageNumber,
        result:[],
        anchorEl:null,

    };
    classes = this.props.classes;

    handleSearch(){
        let {query} = this.state;
        this.setState({
            anchorEl:null,
        })
        this.props.handlePage(query)
    }
    handleClick = (event) => {
        this.setState({
            anchorEl: event.currentTarget
        })
    };
    handleClose = () => {
        this.setState({
            anchorEl: null
        })
    };
    handleChnage(page){
        let {numPages} = this.props;

        if(parseInt(page) > 0){
            if(parseInt(page) <= numPages){
                this.setState({
                    query: parseInt(page)
                })

            }
        }
    }
    render(){
        let {query,anchorEl} = this.state;
        const open = Boolean(anchorEl);
        let {numPages} = this.props;
        return (
            <div>
                <Tooltip arrow title={Translate.goToPage}>
                    <IconButton
                        onClick={this.handleClick.bind(this)}
                        size="small"
                    >
                        <LowPriorityRoundedIcon  fontSize="small"/>
                    </IconButton>
                </Tooltip>

                <Popover
                    className={this.classes.fontSizePopOver}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={() => this.handleClose()}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Box p={2} style={{display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                        <TextField
                            autoFocus
                            variant="outlined"
                            fullWidth
                            size="small"
                            type="number"
                            max={numPages}
                            className="goto-input"
                            label={Translate.pageNumber}
                            value={query}
                            onChange={(e) => this.handleChnage(e.target.value)}
                            /*InputProps={{
                                endAdornment: (

                                ),
                            }}*/
                        />
                        <IconButton
                            onClick={() => this.handleSearch()}
                            size="small"
                            color="secondary"
                            style={{
                                color: "#e4a438 !important",
                                border:"2px solid",
                                marginRight:6,
                                marginLeft:0
                        }}
                        >
                            <ChevronLeftRoundedIcon style={{color:this.props.secondary_color,}}/>
                        </IconButton>
                    </Box>
                </Popover>
            </div>

        );
    }
}
const mstp = state => ({
    user: state.user,
    secondary_color: state.secondary_color,
});
export default withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(PlayerPage))));